module.exports = __webpack_public_path__ + "static/media/shape-contact-us.145c64fd.png";